import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

export const Context = createContext();

export const AuthProvider = ({ children }) => {
  const auth = getAuth();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      console.log("🔁 onAuthStateChanged:", currentUser);
      setUser(currentUser);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  // ✅ Reusable function to get Firebase ID token
  const getToken = async () => {
    if (user) {
      return await user.getIdToken();
    }
    return null;
  };

  const values = {
    user,
    loading,
    getToken, // 🔑 add token getter here
  };

  return (
    <Context.Provider value={values}>
      {!loading && children}
    </Context.Provider>
  );
};

export const useAuth = () => useContext(Context);
